import styled from "styled-components";
import {Input as InputAntD} from "antd";

export const TagTable = styled.div`
    margin: 4px;
    padding: 2px;
    border-radius: 8px;
    background-color: #e4e8ef;
    border-color: #e4e8ef;
    font-size: 11px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.18;
    letter-spacing: normal;
    text-align: center;
    color: #3c4455;
`;

export const TagTableExpanded = styled.div`
    margin: 7px 79px 7px 13px;
    font-size: 12px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #6c7485;
`;

export const LoadingDataUser = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 180px;
`;

export const SearchInput = styled(InputAntD)`
    max-width: 222px;
    height: 42px;
    border-radius: 8px;
    background-color: #e9ecf2;
    border: 0 none; 

    input.ant-input {
      background-color: #e9ecf2;
      color: #6b7384;
  }
`;